"use client";

import { Card, CardContent, CardHeader, cn } from "@saridana-core/react-ui-kit";
import { TCareerInfoGridSection, TContentCard } from "@shared/types";
import Image from "next/image";

export function CareerInfoGridSection({ title, description, image, items, colSize, itemTitle }: TCareerInfoGridSection) {
  return (
    <section className="py-20 sm:py-[100px] lg:py-[120px] bg-white">
      <div className="container relative">
        <div className="flex gap-2 md:gap-[40px] w-full flex-col-reverse md:flex-row mb-[80px] md:mb-[97px] items-start md:items-center justify-between">
          <div
            className={cn(
              "flex flex-col space-y-6",
              image?.data?.attributes?.url ? "text-left xl:max-w-[50rem]" : "text-center xl:max-w-[60%] mx-auto",
            )}
          >
            <h1 className="text-5xl md:text-6xl leading-[115%] font-bold">{title || "Career Information Title"}</h1>
            <p className="text-xl md:text-2xl text-gray-700 leading-[140%]">{description || "Career Information Description"}</p>
          </div>

          <div className="w-[6.25rem] h-[6.25rem] md:min-w-[17.5rem] md:min-h-[17.5rem] md:mx-10">
            {image?.data?.attributes?.url && (
              <Image
                className="rounded-2xl w-container md:w-full h-auto mb-6 md:mb-0"
                src={image?.data?.attributes?.url}
                height={image?.data?.attributes?.height}
                width={image?.data?.attributes?.width}
                alt={image?.data?.attributes?.alternativeText || image?.data?.attributes?.name || "Career Information Section"}
              />
            )}
          </div>
        </div>

        {itemTitle && (
          <div className={cn("mb-9 md:mb-10")}>
            <h3 className="text-2xl md:text-3xl font-bold">{itemTitle || "Career Information Item Title"}</h3>
          </div>
        )}

        {items && items?.length > 0 && <CareerInfoCards items={items} colSize={colSize} />}
      </div>
    </section>
  );
}

export function CareerInfoCards({ items, colSize }: { items: TContentCard[]; colSize: number }) {
  return (
    <div className={cn("grid grid-cols-1", `md:grid-cols-3 gap-12 sm:gap-9 lg:gap-12`)}>
      {items?.map((item: TContentCard) => (
        <Card key={`career-about-item-${item.id}`} className="border-none shadow-none p-0">
          {item?.icon?.data?.attributes?.url && (
            <CardHeader className="p-0 mb-6">
              <div className="bg-primary-600 rounded-md p-2 w-12 h-12">
                <Image
                  className="w-full h-full flex-shrink-0 object-contains"
                  src={item?.icon?.data?.attributes?.url}
                  height={item?.icon?.data?.attributes?.height}
                  width={item?.icon?.data?.attributes?.width}
                  alt={item?.icon?.data?.attributes?.alternativeText || item?.icon?.data?.attributes?.name || "Career About Item Section"}
                />
              </div>
            </CardHeader>
          )}

          <CardContent className="p-0">
            <h3 className="font-bold text-xl leading-[130%] mb-3">{item.title}</h3>
            <p className="text-lg leading-[146%] text-gray-700">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
